export class GettingStartedStore {
    constructor(opts) {
        this.appStore = opts.appStore;
    }

    switchReadOnly() {
        return this.appStore.submissionID &&
        this.appStore.userData &&
        this.appStore.userData.rooms &&
        this.appStore.userData.rooms.room1;
    }
}
